/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const SUCCESS_TEXT = {
  copied: "Copied to clipboard",
} as const;
